import React, { useMemo } from "react";
import { useApiClient } from "../../../../shared/customHooks";
import { useApplicationContext } from "../../context/applicationContext";
import { applicationApprovalFormLegacy } from "../../../../shared/formObjects/application/legacy/applicationApprovalFormLegacy";
import BaseApplicationComponent from "../../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";

function ApplicationApprovalComponentLegacy({ disabled, data }: any) {
  const api = useApiClient("ApplicationApprovalLegacy");

  const { applicationBase, id } = useApplicationContext();

  const context = useMemo(
    () => ({
      isComplex: applicationBase.applicationType?.typeOfApplication === 3,
    }),
    []
  );

  return (
    <>
      {" "}
      <BaseApplicationComponent
        formBody={applicationApprovalFormLegacy}
        headerLabel="Application Approval"
        editPath="applicationApproval"
        apiClient={api}
        disabled={disabled}
        data={data}
        formContext={context}
        id={id}
      />
    </>
  );
}

export default ApplicationApprovalComponentLegacy;
